import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, isHqAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--color-text-tertiary)',
        fontSize: 13,
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isHqAdmin) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 12,
        padding: 40,
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 22, fontWeight: 500 }}>Access denied</div>
        <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', maxWidth: 400 }}>
          This account doesn't have HQ admin access. Agriware HQ is internal only.
        </div>
      </div>
    );
  }

  return children;
}
